export default {"src":"https://fishbrain.com/_next/static/media/activeLinkIcon.ebe3c2d0.svg","height":6,"width":21,"blurWidth":0,"blurHeight":0};